<template>
  <div id="rule-startup">
    <div class="box-logo text-center">
      <div class="w-100">
        <a href="/">
          <img src="@/image/logo1.png" class="logo" />
        </a>
      </div>
    </div>
    <div class="container">
      <div class="box-detail">
        <div class="box-terms">
          <div class="text-center">
            <p class="title-head">
              นโยบายคุ้มครองความเป็นส่วนตัว (Privacy Policy)
            </p>
            <p class="sub-head" style="color:#353535">
              การคุ้มครองความเป็นส่วนตัวและข้อมูลส่วนบุคคลเป็นสิ่งที่ AvocadoX
              ให้ความสำคัญเป็นอย่างยิ่ง
            </p>
          </div>
          <div class="detail">
            <p class="pd-t-15 mg-l-2">
              &emsp;&emsp;&emsp;&emsp;นโยบายฉบับนี้ บริษัท เยสยูแคน จำกัด
              จัดทำขึ้น
              เพื่อให้ความเข้าใจถึงแนวทางปฏิบัติของเราในการจัดการข้อมูลส่วนบุคคล
              (Personal Information) ของผู้ใช้บริการทุกท่าน
              ที่ติดต่อเข้ามายังเว็บไซต์
              <a href="https://avocadox.co/" target="_blank">avocadox.co</a>
              หรือสมัครเข้าใช้บริการของ AvocadoX ดังนี้
              เพื่อประโยชน์และความเข้าใจในการใช้บริการจากทางเรา
              ขอให้ท่านได้โปรดอ่านและทำความเข้าใจเอกสารฉบับนี้โดยละเอียด
            </p>
            <p class="pd-t-15 mg-l-2">
              &emsp;&emsp;&emsp;&emsp;ทั้งนี้ การติดต่อเข้ามายังเว็บไซต์
              หรือสมัครเข้าใช้บริการของ AvocadoX
              ถือว่าท่านยินยอมผูกพันตามนโยบายฉบับนี้ทุกประการ
            </p>
            <p class="pd-t-15 mg-l-2">
              &emsp;&emsp;&emsp;&emsp;คำจำกัดความใดๆ
              ที่ปรากฏในนโยบายคุ้มครองความเป็นส่วนตัวนี้ให้เป็นไปตามที่กำหนดไว้ใน
              เงื่อนไขการใช้บริการ
              <a href="https://avocadox.co/" target="_blank">AvocadoX</a>
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              1. การเก็บรวบรวมข้อมูลส่วนบุคคล
            </p>
            <p class="mg-l-2">
              AvocadoX ให้บริการซอฟต์แวร์ที่มีประสิทธิภาพเทียบเท่าระดับสากล
              ที่ช่วยให้เจ้าของธุรกิจและที่ปรึกษาวางแผนการดำเนินธุรกิจได้ด้วยความสะดวกรวดเร็ว
              ปลอดภัย และมีประสิทธิภาพ
            </p>
            <p class="mg-l-2">
              เพื่อความสะดวกในการให้บริการดังกล่าว AvocadoX
              มีความจำเป็นต้องจัดเก็บรวบรวมข้อมูลส่วนบุคคลของท่านไว้ เช่น ชื่อ,
              อาชีพ, หมายเลขบัตรประชาชน, ที่อยู่, ที่ทำงาน, รหัสไปรษณีย์,
              หมายเลขโทรศัพท์, อีเมล ชื่อผู้ประสานงาน,
              ข้อมูลการจดทะเบียนทางการค้า, และอื่นๆ เป็นต้น
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              2. AvocadoX จะเก็บข้อมูลส่วนบุคคลของท่านเมื่อ
            </p>
            <p class="pd-t-15 mg-l-2">2.1 สมัครใช้บริการ</p>
            <p class="pd-t-15 mg-l-2">2.2 ใช้บริการ</p>
            <p class="pd-t-15 mg-l-2">
              2.3 มีการติดต่อเข้ามายังหน่วยให้ความช่วยเหลือในการใช้งาน (Support
              team)
            </p>
            <p class="pd-t-15 mg-l-2">
              2.4 มีการเข้าชมเว็บไซต์
              ท่านมีสิทธิ์โดยชอบธรรมที่จะไม่ให้ข้อมูลส่วนบุคคลของท่านแก่
              AvocadoX แต่การกระทำเช่นนั้นหมายความว่าท่านจะไม่สามารถใช้บริการใดๆ
              ของ AvocadoX ได้
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              3. การให้ความยินยอมในการใช้ข้อมูลส่วนตัวของท่าน
            </p>
            <p class="pd-t-15 mg-l-2">
              3.1 เมื่อท่านสมัครใช้บริการใดๆ ของ AvocadoX ถือว่าท่านยินยอมให้
              AvocadoX
              เก็บและใช้ข้อมูลดังกล่าวเพื่อวัตถุประสงค์ในการให้บริการตามที่กำหนดไว้ในเงื่อนไขการใช้บริการ
              และตามที่กำหนดไว้ในนโยบายคุ้มครองความเป็นส่วนตัวฉบับนี้เท่านั้น
            </p>
            <p class="pd-t-15 mg-l-2">
              3.2 AvocadoX
              จะใช้ข้อมูลส่วนตัวของท่านเพื่อประโยชน์แก่การดังต่อไปนี้
            </p>
            <p class="mg-l-3">• เพื่อระบุตัวตนของท่าน</p>
            <p class="mg-l-3">• เพื่อประโยชน์ในการให้บริการ</p>
            <p class="mg-l-3">
              • เพื่อประชาสัมพันธ์ในเรื่องการให้บริการ
              หรือการเปลี่ยนแปลงการให้บริการ
            </p>
            <p class="mg-l-3">
              • เพื่อส่งเสริมการตลาด หรือ การอบรมใดๆ
              ที่เกี่ยวข้องกับการให้บริการ
            </p>
            <p class="mg-l-3">
              • เพื่อให้ความช่วยเหลือ และแก้ปัญหาในด้านเทคนิคหรือปัญหาต่างๆ
              อันเกี่ยวกับการบริการ
            </p>
            <p class="mg-l-3">• เพื่อให้เป็นไปตามที่กฎหมายกำหนด</p>
            <p class="mg-l-3">• เพื่อติดต่อสื่อสารกับท่าน</p>
            <p class="mg-l-3">
              • เพื่อตรวจสอบความซ้ำซ้อนของโครงการที่ท่านเข้าร่วม
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              4. หน้าที่ของท่านในการดูแลรักษา Password
            </p>
            <p class="mg-l-2">
              เพื่อให้ AvocadoX
              บรรลุวัตถุประสงค์สำเร็จลุล่วงในการเก็บรักษาข้อมูลส่วนบุคคลของท่าน
              ท่านมีหน้าที่ที่จะต้องเก็บ Password ของท่านไว้เป็นความลับ
              และท่านมีหน้าที่แจ้งให้ AvocadoX
              ทราบในทันทีที่ท่านพบหรือทราบว่ามีการใช้ Password
              ของท่านโดยไม่ได้รับอนุญาต
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              5. การเก็บข้อมูลส่วนบุคคลของบุคคลภายนอก
            </p>
            <p>
              ในกรณีที่ท่านให้ข้อมูลที่เกี่ยวกับบุคคลภายนอกแก่ AvocadoX
              ถือว่าท่านให้การรับประกันว่าท่านกระทำไปโดยมีสิทธิ์
              หรือได้รับอนุญาตโดยชัดแจ้งจากเจ้าของข้อมูลให้กระทำเช่นนั้น
              และท่านอนุญาตให้ AvocadoX จัดเก็บ ใช้ คัดลอก
              ข้อมูลดังกล่าวได้ภายในขอบเขตที่กำหนดไว้ในนโยบายคุ้มครองความเป็นส่วนตัวฉบับนี้
              ทั้งนี้ท่านมีหน้าที่ในการแจ้งให้บุคคลภายนอกดังกล่าวทราบถึงการกระทำดังกล่าวและนโยบายคุ้มครองความเป็นส่วนตัว
              AvocadoX ด้วยตัวท่านเอง AvocadoX ไม่มีความรับผิดใดๆ
              ต่อบุคคลภายนอกและไม่มีหน้าที่ใดๆ
              ในการแจ้งให้บุคคลภายนอกทราบถึงเหตุดังกล่าว
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              6. การเปิดเผยข้อมูลส่วนบุคคล
            </p>
            <p>
              ความลับและข้อมูลส่วนบุคคลของท่านถือเป็นสิ่งสำคัญยิ่ง AvocadoX
              จะไม่เปิดเผยความลับหรือข้อมูลส่วนบุคคลของท่านให้แก่บุคคลภายนอกหรือองค์กรอื่นใด
              ไม่ว่าเพื่อวัตถุประสงค์ใดๆ เว้นแต่
            </p>
            <p>• ได้รับความยินยอมจากท่าน หรือการทำตามคำร้องขอของท่าน</p>
            <p>
              • ในกรณีที่กฎหมายบังคับ เช่น การทำตามคำสั่งศาล หรือหมายศาล เป็นต้น
            </p>
            <p>
              • ชื่อบริษัท เลขประจำตัวผู้เสียภาษี ผู้ประสานงานหลัก
              อีเมลที่ใช้สมัครเข้าร่วมโครงการ และผู้บริหารสูงสุดขององค์กรท่าน
              ชื่อโครงการที่ท่านเข้าร่วม
              รวมถึงชื่อโครงการที่ท่านใช้สมัครเข้าร่วมโครงทั้งภาษาไทยและภาษาอังกฤษ
              เพื่อใช้ในการลงทะเบียนในโครงการอื่นและตรวจสอบความซ้ำซ้อนของโครงการภาครัฐ
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              7.การเก็บและใช้ข้อมูลประเภทที่ไม่ใช่ข้อมูลส่วนบุคคล
            </p>
            <p class="mg-l-2">
              การสมัครใช้บริการของ AvocadoX ถือว่าท่านอนุญาตให้ AvocadoX
              เข้าถึงหรือใช้ข้อมูลประเภทที่ไม่ใช่ข้อมูลส่วนบุคคลของท่านได้
              ในการต่อไปนี้
            </p>
            <p class="mg-l-3">
              • เพื่อช่วยให้เราเข้าใจวิธีการที่ท่านใช้บริการของเรา
            </p>
            <p class="mg-l-3">
              • เพื่อให้ข้อมูลเพิ่มเติมแก่ผู้ใช้บริการเกี่ยวกับการใช้งาน
              และประโยชน์ที่ผู้ใช้บริการจะได้รับเมื่อใช้บริการ
            </p>
            <p class="mg-l-3">
              • เพื่อการช่วยเหลือ สนับสนุน
              และการเพิ่มประสิทธิภาพและประสิทธิผลของธุรกิจขนาดเล็ก
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              8. การเก็บข้อมูลของท่านไว้ในระบบฐานข้อมูล Cloud
            </p>
            <p>
              AvocadoX ใช้บริการของ Cloud
              ซึ่งเป็นผู้นำในการให้บริการด้านระบบฐานข้อมูลชั้นนำของโลกและได้มาตรฐานความปลอดภัยที่ปฏิบัติสอดคล้องกับมาตรฐาน
              ISO27001:2013 ภายใต้การให้บริการของ AvocadoX
              เพื่อการเก็บรักษาข้อมูลส่วนบุคคล และข้อมูลอื่นๆ ของผู้ใช้บริการ
              ดังนั้น การสมัครเข้าใช้บริการของ AvocadoX
              ถือว่าท่านยอมรับว่าข้อมูลของท่านจะถูกเก็บไว้ในระบบฐานข้อมูล ของ
              Cloud ที่ได้มาตรฐานและปลอดภัยในการเก็บข้อมูล
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              9. มาตรฐานในการคุ้มครองข้อมูลส่วนบุคคล
            </p>
            <p>
              AvocadoX รักษามาตรฐานในการรักษาความปลอดภัยโดยเคร่งครัด ทั้งนี้
              เพื่อวัตถุประสงค์ในการปกป้องความเสียหาย
              หรือการเข้าถึงข้อมูลส่วนบุคคลของท่านโดยไม่มีอำนาจ AvocadoX
              ใช้ระบบฐานข้อมูล Cloud ที่ได้มาตรฐานสากล
              ซึ่งมีการป้องกันความปลอดภัยของข้อมูลเทียบเท่าระดับสากล
              เว็บไซต์มีการเข้ารหัส SSL, Firewall
              เพื่อความปลอดภัยในการส่งข้อมูลระหว่างเว็บไซต์กับระบบฐานข้อมูล
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              10. AvocadoX ใช้ “คุกกี้” (Cookies)
            </p>
            <p class="mg-l-2">
              “คุกกี้” คือ
              ไฟล์คอมพิวเตอร์ขนาดเล็กที่ติดตั้งอยู่บนคอมพิวเตอร์ของท่านเพื่อความสะดวกในการจดจำเว็บไซต์
              ที่ท่านเคยเข้าชม “คุกกี้”
              ไม่สามารถใช้เพื่อระบุถึงตัวท่านหรือมีข้อมูลที่เกี่ยวข้องกับตัวท่านแต่ประการใด
              แต่ “คุกกี้”
              นั้นสามารถใช้เพื่อระบุถึงเครื่องคอมพิวเตอร์ของท่านเท่านั้น
            </p>
            <p class="mg-l-2">
              AvocadoX ใช้ “คุกกี้” และเมื่อ “คุกกี้”
              ได้ถูกติดตั้งลงในระบบคอมพิวเตอร์ของผู้ใช้บริการแล้ว
              ก็จะทำให้ผู้ใช้บริการได้รับความสะดวกสบายในการใช้ประโยชน์จากเว็บไซต์
              AvocadoX เนื่องจาก “คุกกี้”
              จะจดจำรูปแบบลักษณะการใช้งานของผู้ใช้บริการเอาไว้ นอกจากนี้
              AvocadoX จะนำข้อมูลที่ “คุกกี้” ได้บันทึกหรือเก็บรวบรวมไว้
              ไปใช้ในการวิเคราะห์เชิงสถิติ หรือในกิจกรรมอื่นของ เว็บไซต์
              เพื่อปรับปรุงคุณภาพการให้บริการต่อไป
            </p>
            <p class="mg-l-2">
              ท่านมีสิทธิ์ปฏิเสธที่จะไม่ใช้ “คุกกี้” ได้ แต่ทั้งนี้
              ท่านจะต้องตระหนักว่าการปฏิเสธการใช้งาน “คุกกี้”
              อาจทำให้ท่านไม่สามารถใช้ประโยชน์จากฟังก์ชันหรือการใช้งานบางอย่างบนเว็บไซต์ของ
              AvocadoX ได้
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              11. สิทธิ์ในการควบคุมข้อมูลส่วนบุคคล
            </p>
            <p class="mg-l-2">
              เพื่อประโยชน์ในการรักษาความเป็นส่วนตัว
              ท่านมีสิทธิ์เลือกที่จะให้มีการใช้หรือแชร์ข้อมูลส่วนบุคคลของท่าน
              หรืออาจเลือกที่จะไม่รับข้อมูลหรือสื่อทางการตลาดใดๆ จากเว็บไซต์
              ก็ได้ โดยเพียงแต่กรอกความจำนงดังกล่าวเพื่อแจ้งให้ AvocadoX
              ทราบตามช่องทางต่างๆ ที่ปรากฏบนหน้าเว็บไซต์
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              12. การร้องเรียนปัญหาเรื่องความเป็นส่วนตัว
            </p>
            <p class="mg-l-2">
              ในกรณีที่ท่านมีปัญหา ข้อสงสัย ข้อเสนอแนะ หรือข้อติชมใดๆ
              เกี่ยวกับนโยบายคุ้มครองความเป็นส่วนตัว
              หรือการปฏิบัติตามนโยบายความเป็นส่วนตัวฉบับนี้ AvocadoX
              ยินดีที่จะตอบข้อสงสัย รับฟังข้อเสนอแนะ และคำติชมทั้งหลาย
              อันจะเป็นประโยชน์ต่อการปรับปรุงการให้บริการต่อไป
              โดยท่านสามารถติดต่อกับ AvocadoX ได้ผ่านทางช่องทางต่างๆ
              ตามที่ปรากฏบนหน้าเว็บไซต์
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              13.
              นโยบายคุ้มครองความเป็นส่วนตัวฉบับนี้อยู่ภายใต้บังคับของเงื่อนไขการใช้บริการ
            </p>
            <p class="mg-l-2">
              การจำกัดความรับผิด หรือยกเว้นความรับผิดของ AvocadoX
              ให้ถือตามที่กำหนดไว้ใน
              <a href="/terms-of-use" target="_blank">เงื่อนไขการใช้บริการ</a>
            </p>

            <p class="pd-t-15 has-text-weight-normal">
              14. การลบข้อมูลออกจากบัญชี AvocadoX
            </p>
            <p class="mg-l-2">
              คุณสามารถลบบัญชี AvocadoX ได้หากต้องการยกเลิกใช้บริการอื่นของ
              AvocadoX
            </p>
            <p class="pd-t-15 mg-l-2">
              สามารถทำตามต่อไปนี้ได้เพื่อลบข้อมูลของคุณ
            </p>
            <p class=" mg-l-4">1. ไปที่เมนู “ข้อมูลส่วนตัว”</p>
            <p class=" mg-l-4">2. คลิกที่ปุ่ม “ลบบัญชี”</p>
            <p class=" mg-l-4">3. คลิกที่ปุ่ม “ลบ” เพื่อทำการยืนยันลบบัญชี</p>
            <a
              href="https://learning.avocadox.co/profile"
              target="_blank"
              class="policy pd-t-15 mg-l-2"
              >ลบข้อมูลของคุณ</a
            >

            <p class="pd-t-15 has-text-weight-normal">
              15. AvocadoX ขอสงวนสิทธิ์
            </p>
            <p class="mg-l-2">
              ขอสงวนสิทธิ์ในการปรับปรุงหรือแก้ไขนโยบายคุ้มครองความเป็นส่วนตัว
              โดยไม่ต้องแจ้งให้ทราบล่วงหน้า ทั้งนี้
              เพื่อความเหมาะสมและมีประสิทธิภาพในการให้บริการ ดังนั้น
              จึงขอแนะนำให้ผู้ใช้บริการอ่านนโยบายความเป็นส่วนตัวทุกครั้งที่แวะชม
              หรือเยี่ยมชม หรือมีการใช้บริการจากเว็บไซต์ของ AvocadoX
            </p>
            <p class="pd-t-15 is-size-7 has-text-right">
              <I>แก้ไขครั้งล่าสุดเมื่อวันที่ 14 ธันวาคม 2564</I>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="scroll-up" @click="upToTop()">
      <div class="icon-menu-up">
        <i class="fas fa-angle-up"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    upToTop() {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    },
  },
};
</script>
